<template>
  <div>
    <SnackbarComponent
      v-model="snackbar.show"
      :message="snackbar.message"
      :color="snackbar.color"
    />

    <v-dialog v-model="dialog" max-width="400px" persistent>
      <v-card>
        <v-card-title class="text-h6">
          Change License Type
        </v-card-title>

        <v-divider />

        <v-card-text class="pa-4">
          <v-select
            v-model="selectedLicense"
            :items="['MRR', 'ANNUAL']"
            label="License Type"
            density="compact"
            variant="outlined"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions class="justify-end pa-4">
          <v-btn variant="text" @click="handleClose">
            Cancel
          </v-btn>

          <v-btn
            color="primary"
            variant="flat"
            :loading="loading"
            :disabled="loading || !selectedLicense"
            @click="updateLicense"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { generateClient } from "aws-amplify/api";
import { change_user_license_type } from "@/graphql/mutations";
import SnackbarComponent from "@/components/Extras/Snackbar.vue";

const client = generateClient();

export default {
  name: "EditUserLicenseDialog",

  components: {
    SnackbarComponent,
  },

  props: {
    modelValue: Boolean,
    user: Object,
  },

  emits: ["update:modelValue", "updated"],

  data() {
    return {
      selectedLicense: null,
      loading: false,
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
    };
  },

  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },

  watch: {
    user: {
      immediate: true,
      handler(val) {
        if (val) {
          this.selectedLicense = val.user_license_type;
        }
      },
    },
  },

  methods: {
    handleClose() {
      this.dialog = false;
    },

    async updateLicense() {
      if (!this.user || !this.selectedLicense) return;

      this.loading = true;

      try {
        const input = {
          target_user_id: this.user.user_id,
          new_license_type: this.selectedLicense,
        };

        const response = await client.graphql({
          query: change_user_license_type,
          variables: {
            input: input,
          },
        });

        const responseData = JSON.parse(
          response.data.change_user_license_type
        );

        if (responseData.status === "SUCCESS") {
          this.snackbar = {
            show: true,
            message:
              responseData.status_message ||
              "License type updated successfully",
            color: "success",
          };

          this.$emit("updated");
          this.handleClose();
        } else {
          this.snackbar = {
            show: true,
            message:
              responseData.status_message ||
              "Failed to update license type",
            color: "error",
          };
        }
      } catch (error) {
        console.error("Error updating license:", error);

        this.snackbar = {
          show: true,
          message:
            error?.errors?.[0]?.message ||
            "Failed to update license type",
          color: "error",
        };
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>